export const STATUS_ESCALATED = 'escalated';
export const STATUS_BOUNCED = 'bounced';
export const STATUS_RESOLVED = 'resolved';
export const STATUS_ACTIVE = 'active';
export const STATUS_UNKNOWN = 'unknown';

export const CONVERSATION_STATS = {
    CLICKS: {
        DISAMBIGUATIONS: 'disambiguations',
        DOCUMENTS: 'documents',
        ESCALATIONS: 'escalations',
        HANDOVERS: 'handovers',
        LINKS: 'links',
        RESPONSES: 'responses',
        THUMBS_UP: 'thumbs_ups',
        THUMBS_DOWN: 'thumbs_downs',
        WEBEXT: 'webexts',
    },
    MESSAGES: {
        TOTAL: 'total',
    },
    QUERIES: {
        ANSWERED: 'answered',
        CHOICE: 'choice',
        MISSING: 'missing',
        TOTAL: 'total',
    },
    USER_ID: 'user_id',
};
